export default __webpack_public_path__ + "static/media/linkedin.551fc4b9.svg";